var _excluded = ["children", "extend", "href", "disabled", "onClick", "target"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import El from '../el';
import useConfig from '../../config/useConfig.js';
var buttonResetStyle = function buttonResetStyle(_ref) {
  var disabled = _ref.disabled;
  return {
    backgroundColor: 'unset',
    backgroundImage: 'unset',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    cursor: 'pointer',
    appearance: 'none',
    borderWidth: 0,
    touchAction: 'manipulation',
    color: 'inherit',
    '::-moz-focus-inner': {
      borderWidth: 0,
      padding: 0
    },
    extend: [{
      condition: disabled,
      style: {
        cursor: 'not-allowed'
      }
    }, {
      condition: !disabled,
      style: {
        ':active': {
          color: 'inherit'
        }
      }
    }]
  };
};
var linkResetStyle = function linkResetStyle(_ref2) {
  var disabled = _ref2.disabled;
  return {
    textDecoration: 'none',
    color: 'inherit',
    extend: [{
      condition: disabled,
      style: {
        cursor: 'not-allowed'
      }
    }, {
      condition: !disabled,
      style: {
        ':active': {
          color: 'inherit'
        }
      }
    }]
  };
};
var Click = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
    extend = _ref3.extend,
    href = _ref3.href,
    disabled = _ref3.disabled,
    onClick = _ref3.onClick,
    target = _ref3.target,
    props = _objectWithoutProperties(_ref3, _excluded);
  var config = useConfig();
  var hasHref = typeof href === 'string' || _typeof(href) === 'object';
  var Link = config.linkComponent || 'a';
  var as = hasHref ? Link : 'button';
  var appliedStyle = as === 'button' ? buttonResetStyle : linkResetStyle;
  var rel = target === '_blank' ? 'noreferrer noopener' : undefined;
  return /*#__PURE__*/React.createElement(El, _extends({}, props, {
    disabled: as === 'button' && disabled,
    href: !disabled && hasHref ? href : undefined,
    onClick: !disabled && onClick ? onClick : undefined,
    target: target,
    rel: rel,
    onTouchStart: function onTouchStart() {},
    ref: ref,
    as: as,
    type: as === 'button' ? props.type || 'button' : null,
    extend: [{
      boxSizing: 'border-box'
    }, appliedStyle({
      disabled: disabled
    }), extend]
  }), children);
});
export default Click;
Click.displayName = 'Click';
Click.propTypes = {
  /** An object containing valid CSS style declarations */
  extend: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.array]),
  /** Setting an href attribute will force the component to render with an `<a>` tag */
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** If rendering a button (by not supplying an href), this let's you provide a type attribute for that button */
  type: PropTypes.string,
  /** A JSX node */
  children: PropTypes.node,
  /** Set the Click to disabled */
  disabled: PropTypes.bool,
  /** An action that is fired on click */
  onClick: PropTypes.func
};